import { render, staticRenderFns } from "./GenericModal.vue?vue&type=template&id=2cf891ef&scoped=true&lang=html&"
import script from "./GenericModal.vue?vue&type=script&lang=js&"
export * from "./GenericModal.vue?vue&type=script&lang=js&"
import style0 from "./GenericModal.css?vue&type=style&index=0&id=2cf891ef&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf891ef",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/generico/GenericModal.vue
// module id = 704
// module chunks = 28